(function( $ ) {

        //filter the html display
        var filtering = function ($el, value, type) {
            
            var data = $el.data(type);
            value = String(value).trim();
            data = String(data).trim();
          
                if(data) {
                         
                    if(value === data) {
                        $el.show();
                        $el.addClass('animated');
                        $el.addClass('fadeInDown');
                    } else {
                        $el.addClass('animated');                        
                        $el.addClass('fadeOutDown');
                        $el.hide();
                    }
                } else {
                    $el.addClass('animated');
                    $el.addClass('fadeOutDown');
                    $el.hide();
                }
                setTimeout(function(){
                    $el.removeClass('fadeInDown');                    
                    $el.removeClass('fadeOutDown');
                    $el.removeClass('animated');
                }, 1005);
            
        };

        // filter the google map marker
        var filterMarker = function (map, value, type) {

            for (var i = 0; i < map.markers.length; i++) {
                var marker = map.markers[i];
                marker.setVisible(true);
                if(marker[type] == value) {
                    marker.setVisible(true);
                   centerMap(map);
                   map.setCenter(marker.getPosition());  
                } else {
                    marker.setVisible(false);
                }
            }
        }

        // reset html display + google map marker
        var resetAll = function(){
            $('#realisations .realisation').each(function(){
                var $el = $(this);
                $el.show();
                $el.addClass('animated');
                $el.addClass('fadeInDown');
                setTimeout(function(){
                    $el.removeClass('fadeInDown');  
                    $el.removeClass('animated');
                }, 1005);
            });
            console.log(map);
            for (var i = 0; i < map.markers.length; i++) {
                var marker = map.markers[i];
                marker.setVisible(true);                
            }
            $('select')[0].selectedIndex = 0;
        }
        var selectFunc = function(select) {
            //filter by client
            $('select#' + select).on('change', function() {
                var filterValue = this.value; 
                if(filterValue == select) {
                    resetAll();
                    return;
                }
                $('#realisations .realisation').each(function(){
                    filtering($(this), filterValue, select);
                });
                filterMarker(map, filterValue, select);
                var otherSelect = $('select').not('#'+select);
                otherSelect.each(function(){
                    $(this)[0].selectedIndex = 0;
                });
            });


        }

    /*
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date	22/10/19
     * @since	5.8.6
     *
     * @param	jQuery $el The jQuery element.
     * @return	object The map instance.
     */
    function initMap( $el ) {
        
        // Find marker elements within map.
        var $markers = $el.find('.marker');
        
        // Create gerenic map.
        var mapArgs = {
            zoom		: $el.data('zoom') || 16,
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map( $el[0], mapArgs );
        
        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });
        
        // Center map based on markers.
        centerMap( map );
        
        // Return map instance.
        return map;
        
    }
    
    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date	22/10/19
     * @since	5.8.6
     *
     * @param	jQuery $el The jQuery element.
     * @param	object The map instance.
     * @return	object The marker instance.
     */
    function initMarker( $marker, map ) {
    
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var client = $marker.data('client');
        var prestation = $marker.data('prestation');
        var year = $marker.data('year');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        var title = $marker.attr('data-title');
		var address = $marker.attr('data-address');
		var group = $marker.attr('data-group');
		var color = '';

		switch(group) {
			case "auscultations":
				color = '#debb0e';
				break;
			case "diagnostiques":
				color = '#de950e';
				break;
			case "etudes":
				color = '#0e74de';
				break;
			case "controles":
				color = '#0ede7e';
				break;
			default:
				color = "#c72127";
		}

		var icon = {
			path: google.maps.SymbolPath.CIRCLE,
			scale: 7,
			strokeWeight: 2,
			fillColor: color,
			strokeColor: '#fff',
			fillOpacity:1
		};

		// Create marker instance.
		var marker = new google.maps.Marker({
			position : latLng,
			map: map,
			title: title,
			address: address,
			icon: icon,
            client: client,
            prestation: prestation,
            year: year
		});
    
        
    
        // Append to reference for later use.
        map.markers.push( marker );
    
        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){
            
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });
    
            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }


    
    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date	22/10/19
     * @since	5.8.6
     *
     * @param	object The map instance.
     * @return	void
     */
    function centerMap( map ) {
    
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });
    
        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );
        
        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }
    
    // Render maps on page load.
    var map = null;
    $(document).ready(function(){

        // Instanciate map
        $('.acf-map').each(function(){
            map = initMap( $(this) );
        });

        // Control display + map
        //reset
        $('button#reset').click(function(){
           resetAll();
        });

        $('.map-control select').each(function(){
            var select = $(this).attr('id');
            selectFunc(select);
        });
      
    });
    
    })(jQuery);

       